// DS: i4.34
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const Shop: React.FC<Props> = props => (
  <IconWrap {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path d="M6 3H8H10H12H14H16H18V5H20V7H21V9V11H19V9H17V11H15V9H13V11H11V9H9V11H7V9H5V11H3V9V7H4V5L6 5V3ZM18 21H16H14V19V17V15H12H10V17V19V21H8H6V19V17V15V13H8H10H12H14H16H18H20V15V17V19V21H18ZM4 13H6V15V17V19V21H4V19V17V15V13Z" />
    </svg>
  </IconWrap>
);
Shop.displayName = 'Shop';

export default Shop;
